export function bankLogo(bankName) {
    if(bankName === "BPPB" || bankName ===" bppb") {
        return 'pugebas-logo';
    } else if(bankName === "MEDIOLANUM" || bankName === "mediolanum"){
        return 'banca_mediolanum';
    } else if(bankName === "VERTI" || bankName === "verti") {
        return 'verti';
    } else if(bankName === "OPTIMA" || bankName === "optima") {
        return 'optima';
    }
    return 'plick_logo_white';
}

export function bankColors(bankName) {
    if(bankName === "BPPB" || bankName === "bppb") {
        return 'header BPPB-auth-gradient py-7 py-lg-8';
    }else if(bankName === "MEDIOLANUM" || bankName === "mediolanum") {
        return 'header MEDIOLANUM-auth-gradient py-7 py-lg-8';
    }else if(bankName === "VERTI" || bankName === "verti") {
        return 'header VERTI-auth-gradient py-7 py-lg-8';
    } else if(bankName === "OPTIMA" || bankName === "optima") {
        return 'header OPTIMA-auth-gradient py-7 py-lg-8'
    }
    return 'header plick-auth-gradient py-7 py-lg-8';
}

export function bankUrl(bankName) {
    if(bankName === "BPPB" || bankName === "bppb") {
        return 'https://www.bppb.it/';
    } else if(bankName === "MEDIOLANUM" || bankName === "mediolanum") {
        return 'https://www.bancamediolanum.it/';
    } else if(bankName === "VERTI" || bankName === "verti") {
        return 'https://www.verti.it';
    } else if(bankName === "OPTIMA" || bankName === "optima") {
        return 'https://www.optimaitalia.com';
    }
    return 'https://www.plick.eu';
}

export function bankLogoutRedirect(bankName) {
    if(bankName === "BPPB" || bankName === "bppb") {
        return '/BPPB';
    }else if(bankName === "MEDIOLANUM" || bankName === "mediolanum") {
        return '/MEDIOLANUM';
    } else if(bankName === "VERTI" || bankName === "verti") {
        return '/VERTI';
    } else if(bankName === "OPTIMA" || bankName === "optima") {
        return '/OPTIMA';
    }
    return '/paydo';
}